const API_ENDPOINT = 'https://intellyx-chat-backend.vercel.app/api/chat';
//const API_ENDPOINT = 'http://localhost:3001/api/chat';

const getAge = (article_date_date_format) => {
  const articleDate = article_date_date_format ? new Date(article_date_date_format) : null;
            let age = null;

            if (articleDate) {
              const now = new Date();
              const diffMs = now - articleDate;
              const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

              if (diffDays < 14) {
                age = diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
              } else if (diffDays < 30) {
                const weeks = Math.floor(diffDays / 7);
                age = weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
              } else if (diffDays < 365) {
                const months = Math.floor(diffDays / 30);
                age = months === 1 ? '1 month ago' : `${months} months ago`;
              } else {
                const years = Math.floor(diffDays / 365);
                age = years === 1 ? '1 year ago' : `${years} years ago`;
              }
            }

            return age;
}



export const sendMessage = async (message, sessionId, author, token) => {
  try {
    const requestBody = {
      message: message,
      sessionId: sessionId,
      recaptchaToken: token
    };

    // Only include author in payload if it's not "all"
    if (author !== 'all') {
      requestBody.author = author;
    }

 
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, response: ${errorText}`);
    }

    // Parse the JSON response
    const data = await response.json();
    console.log('API Response:', data);
    const similarityThreshold = 0.39;
    
    // Check if this is a multi-author query (for "all" tab)
    if (author === 'all' && data.multiAuthorQuery && data.responses && Array.isArray(data.responses)) {
      // Process each response in the array
      const processedResponses = data.responses.map(responseItem => {
        let formattedOutput = responseItem.response;
        let documents = [];
        
        // Extract documents from documentsSimilarity array
        if (responseItem.documentsSimilarity && Array.isArray(responseItem.documentsSimilarity)) {
          // Get distinct documents based on file_id and sum similarities for duplicates
          const documentMap = new Map();
          
          responseItem.documentsSimilarity.forEach(doc => {
            if (documentMap.has(doc.file_id)) {
              // Sum similarities for duplicate file_ids
              const existing = documentMap.get(doc.file_id);
              existing.similarity += doc.similarity || 0;
            } else {
              // Add new document  -if similarity is > 0.39
           if (doc.similarity === undefined || doc.similarity >= similarityThreshold) {
            let age = getAge(doc.article_date_date_format);
                
              documentMap.set(doc.file_id, {
                file_id: doc.file_id,
                file_name: doc.file_name,
                similarity: doc.similarity || 0,
                ...(age && { age }) // only include 'age' if it's calculated
              });
            }

            }
          });
          
          documents = Array.from(documentMap.values());
        }
        
        // Format the text for better readability
        formattedOutput = formattedOutput
          // Replace escaped newlines with actual newlines
          .replace(/\\n/g, '\n')
          // Fix numbered lists - remove line breaks between number and bold text
          .replace(/(\d+\.)\s*\n\s*(\*\*[^*]+\*\*:)/g, '$1 $2')
          // Clean up excessive consecutive newlines (more than 3 in a row)
          .replace(/\n{4,}/g, '\n\n')
          // Trim whitespace from start and end
          .trim();
        
        return {
          author: responseItem.author,
          text: formattedOutput,
          documents: documents
        };
      });
      
      return {
        responses: processedResponses,
        multiAuthorQuery: data.multiAuthorQuery
      };
    } else {
      // Handle single response format
      let formattedOutput;
      let documents = [];
      
      if (data.responses && Array.isArray(data.responses) && data.responses.length > 0) {
        // Extract the response from the first item in the responses array
        formattedOutput = data.responses[0].response;
        
        // Extract documents from documentsSimilarity array
        if (data.responses[0].documentsSimilarity && Array.isArray(data.responses[0].documentsSimilarity)) {
          // Get distinct documents based on file_id and sum similarities for duplicates
          const documentMap = new Map();
          
          data.responses[0].documentsSimilarity.forEach(doc => {
            if (documentMap.has(doc.file_id)) {
              // Sum similarities for duplicate file_ids
              const existing = documentMap.get(doc.file_id);
              existing.similarity += doc.similarity || 0;
            } else {
              // Add new document
              if (doc.similarity === undefined || doc.similarity >= similarityThreshold) {
              let age = getAge(doc.article_date_date_format);
                  
                documentMap.set(doc.file_id, {
                  file_id: doc.file_id,
                  file_name: doc.file_name,
                  similarity: doc.similarity || 0,
                  ...(age && { age }) // only include 'age' if it's calculated
                });
              }
            }
          });
          
          documents = Array.from(documentMap.values());
        }
      } else {
        // Fallback to old format for backward compatibility
        formattedOutput = data.response || data.message || JSON.stringify(data);
      }
      
      // Format the text for better readability
      formattedOutput = formattedOutput
        // Replace escaped newlines with actual newlines
        .replace(/\\n/g, '\n')
        // Fix numbered lists - remove line breaks between number and bold text
        .replace(/(\d+\.)\s*\n\s*(\*\*[^*]+\*\*:)/g, '$1 $2')
        // Clean up excessive consecutive newlines (more than 3 in a row)
        .replace(/\n{4,}/g, '\n\n')
        // Trim whitespace from start and end
        .trim();
      
      return {
        text: formattedOutput,
        documents: documents
      };
    }
  } catch (error) {
    console.error('Error sending message:', error);
    console.error('Error details:', {
      message: error.message,
      stack: error.stack,
      endpoint: API_ENDPOINT
    });
    throw error;
  }
}; 